export default {
  "content": "<path fill=\"#fff\" d=\"M.5 1.25C.5.84.84.5 1.25.5h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "8",
    "height": "2",
    "fill": "none",
    "viewBox": "0 0 8 2"
  }
};